import React, { useContext }  from 'react';
import { useTranslation } from 'react-i18next';
import MetricDonutChart from './MetricDonutChart';
import { DataContext } from '../../contexts/DataContext';
import { calculateTotalEmissionsAndAbsorption } from '../../utils/emissionSegmentUtils';


function MetricCard({ emissionSegments }) {
  const { t } = useTranslation();

  const { data } = useContext(DataContext);

  // 合計値を取得
  const { totalEmission, totalAbsorption } = calculateTotalEmissionsAndAbsorption(data);

  const absorptionSegments = Array.from({ length: 8 }, (_, index) => ({
    color: 'url(#greyToGreen)',
    dasharray: '31.42 251.33',
    dashoffset: `-${index * 31.42}`,
  }));

  return (
    <div className="metrics-card">
      <div className="metrics-grid">
        <MetricDonutChart
          segments={emissionSegments}
          value={totalEmission.toFixed(2)}
          label={t('metricCard.emissionLabel')}
          icon="/images/icon/icon_arrow_up.svg"
          iconAlt="up arrow"
        />
        <MetricDonutChart
          segments={absorptionSegments}
          value={totalAbsorption.toFixed(2)}
          label={t('metricCard.absorptionLabel')}
          icon="/images/icon/icon_arrow_down.svg"
          iconAlt="down arrow"
        />
      </div>
      <div className="waste-info">
      {t('metricCard.footprintNote')}
      </div>
    </div>
  );
}

export default MetricCard;
